var chunkMapping = {
	"100": [
		6100
	],
	"397": [
		1397
	],
	"603": [
		603
	],
	"632": [
		3632
	],
	"824": [
		4681,
		9059
	]
};
var idToExternalAndNameMapping = {
	"603": [
		"default",
		"./filter-select",
		19
	],
	"1397": [
		"default",
		"./filter-input",
		19
	],
	"3632": [
		"default",
		"./document-list",
		19
	],
	"4681": [
		"default",
		"./handlers",
		4783
	],
	"6100": [
		"default",
		"./plan-list",
		4783
	],
	"9059": [
		"default",
		"./handlers",
		19
	]
};
var idToRemoteMap = {
	"603": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	],
	"1397": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	],
	"3632": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	],
	"4681": [
		{
			"externalType": "script",
			"name": "planApp"
		}
	],
	"6100": [
		{
			"externalType": "script",
			"name": "planApp"
		}
	],
	"9059": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"603": {
		"shareScope": "default",
		"name": "./filter-select",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	},
	"1397": {
		"shareScope": "default",
		"name": "./filter-input",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	},
	"3632": {
		"shareScope": "default",
		"name": "./document-list",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	},
	"4681": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 4783,
		"remoteName": "planApp"
	},
	"6100": {
		"shareScope": "default",
		"name": "./plan-list",
		"externalModuleId": 4783,
		"remoteName": "planApp"
	},
	"9059": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}